import { paths } from 'routes';
import { AuthenticatedRoute } from 'routes/components';
import {
  BigWorkshopCreate,
  BigWorkshopEdit,
  PositionedWorkshopCreate,
  PositionedWorkshopEdit,
  PositionedWorkshopEntitiesList,
  PositionedWorkshopList,
  WorkshopCreate,
  WorkshopEdit,
  WorkshopList,
} from 'scenes';

const workshopRoutes = [
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.workshop.home,
      exact: true,
      component: WorkshopList,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.workshop.create,
      exact: true,
      component: WorkshopCreate,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.workshop.edit,
      exact: true,
      component: WorkshopEdit,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.workshop.positionedWorkshop.home,
      exact: true,
      component: PositionedWorkshopList,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.workshop.positionedWorkshop.create,
      exact: true,
      component: PositionedWorkshopCreate,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.workshop.positionedWorkshop.edit,
      exact: true,
      component: PositionedWorkshopEdit,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.workshop.callList.home,
      exact: true,
      component: PositionedWorkshopEntitiesList,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.bigWorkshop.create,
      exact: true,
      component: BigWorkshopCreate,
    },
  },
  {
    render: AuthenticatedRoute,
    props: {
      path: paths.front.bigWorkshop.edit,
      exact: true,
      component: BigWorkshopEdit,
    },
  },
];

export { workshopRoutes };
